import { styled } from '@/shared/ui';

export const StyledNav = styled('nav')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

export const StyledUlMain = styled('ul')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  listStyle: 'none',
  padding: 0,
  margin: 0,
  marginBottom: '30px',
  width: '100px',
}));

export const StyledUlAdditional = styled('ul')(() => ({
  display: 'flex',
  flexDirection: 'column',
  listStyle: 'none',
  padding: 0,
  margin: 0,
}));
